import styled from "styled-components";

export const Styled = styled.div`
  & {
    height: 100%;
    pre {
      overflow: visible;
    }
  }
`;
